import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import itemColor from "../../common/util/itemColor";

export default class InfoImportSuccessModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    const returnData = this.attrs.returnData;
    const infoType = returnData.data.attributes.type;
    this.itemColor = itemColor(infoType);

    this.infoSN = returnData.data.attributes.sn;
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.info-import-success');
  }

  content() {
    const infoSNStyle = "background:rgb("+this.itemColor+");font-size: 20px;color: var(--text-color);padding: 4px;border-radius: var(--border-radius);margin-left: 15px;";

    return (
      <div className="Modal-body">
        <div className="Form" style="text-align: center;width: 250px;margin-left: 30px;">
          <div style="font-size: 12px;padding-bottom: 20px;text-align: left;color: gray;margin-top: -10px;">
            <div style="margin-top: -25px;">
              <span>{app.translator.trans('ziven-u2di.forum.info-import-success-sn')}</span>
              <span style={infoSNStyle}>{this.infoSN}</span>
            </div>
          </div>
          <div>
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.ok')
            )}
          </div>
        </div>
      </div>
    );
  }
}
